import { render, staticRenderFns } from "./FooterModule.vue?vue&type=template&id=154dc2dd&scoped=true"
import script from "./FooterModule.vue?vue&type=script&lang=js"
export * from "./FooterModule.vue?vue&type=script&lang=js"
import style0 from "./FooterModule.vue?vue&type=style&index=0&id=154dc2dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154dc2dd",
  null
  
)

export default component.exports